import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 4, 
        backgroundColor: 'background.paper',
        borderTop: 1, 
        borderColor: 'divider' 
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: { xs: 2, sm: 0 } }}>
            © {new Date().getFullYear()} CribCritic. All rights reserved.
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 0, sm: 0 }, // Reduced gap on mobile, keep original for larger screens
            flexWrap: 'wrap',
            justifyContent: 'center' 
          }}>
            <Button 
              size="small" 
              color="inherit"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/privacy-policy')}
            >
              Privacy Policy
            </Button>
            <Button 
              size="small" 
              color="inherit"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/terms-of-service')}
            >
              Terms of Service
            </Button>
            <Button 
              size="small" 
              color="inherit"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/disclaimer')}
            >
              Disclaimer
            </Button>
            <Button 
              size="small" 
              color="inherit"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/refunds')}
            >
              Refund Policy
            </Button>
            <Button 
              size="small" 
              color="inherit"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/contact')}
            >
              Contact
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;